<template>
  <div>
    <!-- 添加 -->
    <template>
      <Modal v-model="visible" title="添加用户" draggable class-name="vertical-center-modal" ok-text="添加" width="730" height="300"
        style="overflow: hidden;" @on-ok="ok" @on-cancel="cancel" :loading="loading">
        <Form ref="details" :model="details" :rules="ruleValidate" label-position="right" :label-width="120" style="width: 714px; height: 400px; margin: 0 auto; overflow-y: auto; padding-top: 20px;">

          <Row span="24">
            <Col span="10" v-if="IsSuperAdmin == '1'">
              <FormItem label="选择集团" prop="GroupCode">
                <Select v-model="details.GroupCode" @on-change="onChange">
                  <Option v-for="item in groupList" :key="item.Id" :value="item.GroupCode">{{item.GroupName}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="选择公司" prop="CompanyCode">
                <Select v-model="details.CompanyCode" @on-change="onCompanyChange">
                  <Option v-for="item in companyList" :key="item.Id" :value="item.CompanyCode">{{item.CompanyName}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>

          <Row span="24">
            <Col span="10">
              <FormItem label="选择部门" prop="DepartmentCode">
                <Select v-model="details.DepartmentCode">
                  <Option v-for="item in departmentList" :key="item.Id" :value="item.DepartmentCode">{{item.DepartmentName}}</Option>
                </Select>
              </FormItem>
            </Col>            
            <Col span="10">
              <FormItem label="员工编号" prop="EmployeeNumber">
                <Input v-model="details.EmployeeNumber" placeholder="请输入员工编号"></Input>
              </FormItem>
            </Col>
          </Row>

          <Row span="24">
            <Col span="10">
              <FormItem label="登录用户名" prop="LoginCode">
                <Input v-model="details.LoginCode" placeholder="请输入登录用户名"></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="用户登录密码" prop="LoginPassword">
                <Input v-model="details.LoginPassword" placeholder="请输入登录密码"></Input>
              </FormItem>
            </Col>
          </Row>

          <Row span="24">
            <Col span="10">
              <FormItem label="姓名" prop="Name">
                <Input v-model="details.Name" placeholder="请输入姓名"></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="移动电话" prop="Phone">
                <Input v-model="details.Phone" placeholder="请输入移动电话"></Input>
              </FormItem>
            </Col>
          </Row>

          <Row span="24">
            <Col span="10">
              <FormItem label="是否管理员" prop="IsAdmin">
                <Select v-model="details.IsAdmin">
                    <Option value="1">是</Option>
                    <Option value="0">否</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </Modal>
    </template>
  </div>
</template>

<script>
import { GetGrouplists, GetCompanyLists, GetDepartmentLists } from "@/api/url_api.js";
 import Cookies from "js-cookie";
 export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false,
        formLeft: {},
        loading: true,

        // groupCode: '',
        companyCode: '',

        groupList: [],
        companyList: [],
        departmentList: [],

        groupCode: Cookies.get('GroupCode'),
        IsSuperAdmin: Cookies.get('IsSuperAdmin'),

        ruleValidate: {
          GroupCode: [{ required: true, message: '请选择集团', trigger: 'change' }],
          CompanyCode: [{ required: true, message: '请选择公司', trigger: 'change' }],
          DepartmentCode: [{ required: true, message: '部门编号不能为空', trigger: 'change' }],
          EmployeeNumber: [{ required: true, message: '员工编号不能为空', trigger: 'blur' }],
          LoginCode: [{ required: true, message: '登录用户名不能为空', trigger: 'blur' }],
          LoginPassword: [{ required: true, message: '用户登录密码不能为空', trigger: 'blur' }],
          Name: [{ required: true, message: '姓名', trigger: 'blur' }],
          IsAdmin: [{ required: true, message: '是否管理员', trigger: 'change' }]
        }
      }
    },
    watch: {
      isShow(newValue, old) {
        this.visible = newValue;
        if (this.visible) {
          if (this.IsSuperAdmin == '1') {
            // 获取集团列表（不带分页）
            this.getGrouplists();
          } else {
            this.onChange(this.groupCode);
          }           
        }
      }
    },
    mounted() {

    },
    methods: {

      // 获取集团列表（不带分页）
      getGrouplists() {
        let _this = this;
        GetGrouplists().then(res => {
          if (res.Success) {
            _this.groupList = res.Data;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 根据id获取公司
      onChange(value) {
        let _this = this;
        _this.groupCode = value;
        _this.getCompanyLists(value);
      },

      // 获取公司列表不带分页
      getCompanyLists(id) {
        let _this = this;
        GetCompanyLists(`?groupCode=${id}`).then(res => {
          if (res.Success) {
            if (_this.IsSuperAdmin == '1') {
              _this.details.CompanyCode = '';
            }  
            _this.companyList = res.Data;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 根据id获取部门
      onCompanyChange(value) {
        let _this = this;
        _this.companyCode = value;
        _this.getDepartmentLists(_this.groupCode, value);
      },

      // 获取部门列表（不带分页）
      getDepartmentLists(groupCode, companyCode) {
        let _this = this;
        GetDepartmentLists(`?groupCode=${groupCode}&companyCode=${companyCode}`).then(res => {
          if (res.Success) {
            _this.details.DepartmentCode = '';
            _this.departmentList = res.Data;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      ok(value) {
        let _this = this;
        _this.$refs.details.validate(valid => {
            if (valid) {
              if (_this.IsSuperAdmin == '0') {
                  _this.details.GroupCode = _this.groupCode;
                }
                _this.$emit("on-change", false, _this.details);
            } else {
                _this.$Message.error("请输入必填项");
                _this.loading = false;
                _this.$nextTick(() => {
                    _this.loading = true;
                });
            }
        });

      },
      cancel(value) {
        this.$emit("on-change", this.visible)
      }
    },
  }
</script>

<style scoped="scoped">

</style>
